import { useState, useEffect } from 'react';
import { StoreInfoPage } from './store/StoreInfoPage';
import { DesktopStoreInfoPage } from './desktop/DesktopStoreInfoPage';

export function ResponsiveStoreInfoPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <StoreInfoPage /> : <DesktopStoreInfoPage />;
}